import { useState } from "react";
import type { FormEvent } from "react";
import { Link, useParams } from "react-router-dom";
import { api, toApiError, unwrap } from "../../api/client";
import { t } from "../../i18n/t";
import { routes } from "../../lib/routes";
import { usePageTitle } from "../../lib/usePageTitle";
import { PasswordFields, passwordProblem } from "./PasswordFields";

export function ResetPasswordPage() {
  const { token = "" } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  usePageTitle(t("auth.resetTitle"));

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    const problem = passwordProblem(password, confirm);
    if (problem) {
      setError(problem);
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await unwrap(api.POST("/api/auth/password-reset/confirm", { body: { token, password } }));
      setDone(true);
    } catch (err) {
      setError(toApiError(err).userMessage);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-card card">
      <h1>{t("auth.resetTitle")}</h1>
      {done ? (
        <>
          <p className="notice notice-success" role="status">
            {t("auth.resetDone")}
          </p>
          <p>
            <Link to={routes.login()} className="btn btn-primary">
              {t("auth.toLogin")}
            </Link>
          </p>
        </>
      ) : (
        <form onSubmit={(e) => void onSubmit(e)} noValidate>
          <PasswordFields
            password={password}
            confirm={confirm}
            onPassword={setPassword}
            onConfirm={setConfirm}
          />
          {error && (
            <p className="notice notice-error" role="alert">
              {error}
            </p>
          )}
          <div className="form-actions">
            <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
              {t("auth.resetSubmit")}
            </button>
          </div>
          <p>
            <Link to={routes.forgotPassword()}>{t("auth.forgotLink")}</Link>
          </p>
        </form>
      )}
    </div>
  );
}
